import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

export const WheelsImageContainer = ({ imageBackgroundCar, imageForegroundWheel, trimName, ...props }) => {

    return (
        <div className='mz-wheels-images-container'>
            <h2 className="mz-wheels-images-container__tittle">{ReactHtmlParser(trimName)}</h2>
            <div className="mz-wheels-images-container__background-image-container">
                <img className="mz-wheels-images-container__background-image" src={imageBackgroundCar}/>
				{ imageForegroundWheel ?
					<div className="mz-wheels-images-container__foreground-image-container">
						<img className="mz-wheels-images-container__foreground-image" src={imageForegroundWheel}/>
					</div>
					: <></>
				}
            </div>

        </div>
    )
}

export default WheelsImageContainer;

WheelsImageContainer.propTypes = {
    imageBackgroundCar: PropTypes.string,
    imageForegroundWheel: PropTypes.string,

}

WheelsImageContainer.defaultProps = {
    imageBackgroundCar: '/jellies/mazda-logo-placeholder.png',
    imageForegroundWheel: ''
};